var map = {
	"./1.jpg": [
		7778,
		778
	],
	"./2.jpg": [
		2204,
		204
	],
	"./3.jpg": [
		8314,
		314
	],
	"./4.jpg": [
		1655,
		655
	],
	"./5.jpg": [
		8122,
		122
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6161;
module.exports = webpackAsyncContext;